import { type OfferV11 } from '@redteclab/api/clients/bully'

import { type CartIntermediateProductInfoSellerData } from '../components/CartIntermediateProductInfo/CartIntermediateProductInfoSellerLink/CartIntermediateProductInfoSellerLink'

export const cartIntermediateAccessorGetSellerData = (
  offer: OfferV11 | undefined,
): CartIntermediateProductInfoSellerData | undefined => {
  if (!offer?.seller) {
    return undefined
  }

  return {
    sellerId: offer.seller.sellerId,
    sellerName: offer.seller.displayName,
  }
}
